export default __webpack_public_path__ + "static/media/medal-2.e9b68671.svg";